<template>
	<div class="conditions-group flex-space-between--center">
		<div class="condition-editor">
			<div class="column-name">
				<ConditionSourceParamType :param="sourceParamType" v-bind="componentProps" v-on="componentListeners" :items="tableItems" />
			</div>
			<div class="condition-selector-container" :class="{ [getSingularClassName(conditionGroupId)]: true }">
				<div class="condition-selector">
					<AppSelect
						item-value="operator"
						item-text="displayText"
						:attach="`.condition-selector-container.${getSingularClassName(conditionGroupId)}`"
						naked
						v-model="condition"
						:items="selectOptions"
						return-object
						@change="onChange"
					/>
				</div>
			</div>
			<div class="condition-value-type-selector-container" :class="{ [getSingularClassName(conditionGroupId)]: true }">
				<div class="condition-value-type-selector">
					<AppSelect
						v-if="showValueInput"
						:attach="`.condition-value-type-selector-container.${getSingularClassName(conditionGroupId)}`"
						naked
						v-model="conditionValueType"
						:items="selectValueTypeOptions"
						@change="onConditionValueTypeChange"
						:disabled="!conditionValueTypeEnabled"
					/>
				</div>
			</div>
			<div class="value-input" :class="{ disabled: !showValueInput }">
				<ConditionSourceParamType
					v-if="showValueInput"
					:param="valueParamType"
					v-on="componentListeners"
					:items="tableTwoItems"
					v-bind="{ ...componentProps, sourceOfList: itemsTwoSourceOfList }"
					@update-condition-tab="updateConditionTab"
				/>
			</div>
		</div>
		<div class="remove-btn" v-show="canRemove">
			<RemoveIcon class="remove-icon" @click="$emit('removeOption', conditionGroupId)" />
		</div>
	</div>
</template>

<script>
import ConditionSourceParamType from '../../../BlockEditorParams/ParamTypes/RulesParams/ConditionSourceParamType';
import { PREVIOUS_STEP_TABLE_OUTPUT } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';
import RemoveIcon from '../../../../BlockEditorWidget/assets/icon-remove-option.svg';
import ConditionEditorMixin from './ConditionEditorMixin';
import { ConditionValueTypes } from '@ply-io/conditions';
export default {
	name: 'AdvanceValueConditionEditor',
	mixins: [ConditionEditorMixin],
	props: {
		itemsTwo: { type: Array },
		itemsTwoSourceOfList: { type: String },
	},
	components: {
		ConditionSourceParamType,
		RemoveIcon,
	},
	computed: {
		tableTwoItems() {
			return this.itemsTwo;
		},
		selectValueTypeOptions() {
			return [
				{ text: "Some item's value in table 2, column:", value: ConditionValueTypes.SingleItem },
				{ text: "All items' values in table 2, column:", value: ConditionValueTypes.AllItems },
			];
		},
	},
	methods: {
		onConditionValueTypeChange() {
			const toUpdate = { ...this.conditionGroup, ...{ conditionValueType: this.conditionValueType } };
			Object.assign(this.conditionGroup, toUpdate);
			this.onChange();
		},
		updateConditionTab(val) {
			this.conditionValueTypeEnabled = val === PREVIOUS_STEP_TABLE_OUTPUT;
		},
	},
	watch: {},
	mounted() {
		this.conditionValueType = this.conditionGroup?.conditionValueType || ConditionValueTypes.SingleItem;
	},
	data: () => ({
		conditionValueType: ConditionValueTypes.SingleItem,
		conditionValueTypeEnabled: true,
	}),
};
</script>

<style scoped lang="scss">
@import './condition-editor.scss';
.conditions-group {
	.condition-editor {
		$border-radius: 9px;
		.condition-selector-container {
			// width: 340px;
			.condition-selector {
				width: 100%;
				max-width: none;
				border-right: none;
				border-bottom: 1px solid var(--border-color);
				border-bottom-left-radius: 0px;
				::v-deep {
					.v-input {
						width: 100%;
					}
				}
			}
		}
		.condition-value-type-selector-container {
			position: relative;
			::v-deep {
				.v-select__selection--comma {
					margin: 0;
				}
				.v-list-item {
					min-height: 24px;

					.v-list-item__content {
						padding: 6px 0;
					}
					.v-list-item__title {
						font-size: 12px;
					}
				}
			}

			.condition-value-type-selector {
				border-bottom: 1px solid var(--border-color);
				height: 100%;
			}
		}
	}
}
</style>
